
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"51","viewBox":"0 0 66 51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.688 8.881h49.953v23.135H7.688z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"3.712","d":"M7.688 36.47h49.953M7.688 40.677h49.953"}})])
          )
        }
      }
    